// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__1Hfke","cardHeader":"styles_cardHeader__3vt6s"};